import script from "./ResistanceModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResistanceModule.vue?vue&type=script&setup=true&lang=ts"

import "./ResistanceModule.vue?vue&type=style&index=0&id=2487c050&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2487c050"]])

export default __exports__